import { render } from "./services.vue?vue&type=template&id=30812d69&scoped=true&ts=true"
import script from "./services.vue?vue&type=script&lang=ts"
export * from "./services.vue?vue&type=script&lang=ts"

import "./services.vue?vue&type=style&index=0&id=30812d69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30812d69"]])

export default __exports__